// ==================== FILE: src/config/TemplateStyles.js ====================
// Template Styles Configuration - Standardized sequential numeric naming (TEMPLATE1, TEMPLATE2, etc.)

import { brandingService } from './brandingService';

export const TEMPLATES = {
  TEMPLATE1: {
    id: 'template1',
    name: 'Modern',
    description: 'A professional and decent Crimson Red & Charcoal design for a premium brand identity',
    fonts: {
      primary: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      secondary: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      heading: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      googleFonts: "family=Montserrat:wght@300;400;500;600;700;800"
    },
    colors: {
      primary: '#B91C1C', secondary: '#18181B', accent: '#D4AF37', accentAlt: '#B91C1C',
      text: '#000', textLight: '#000', textInverse: '#FFFFFF', background: '#fff',
      backgroundAlt: '#fff', backgroundDark: '#111827', border: '#E5E7EB', borderAccent: '#B91C1C',
      overlay: 'rgba(0, 0, 0, 0.7)', overlayLight: 'rgba(0, 0, 0, 0.4)', shadow: 'rgba(0, 0, 0, 0.08)',
      shadowStrong: 'rgba(0, 0, 0, 0.15)', success: '#15803D', error: '#B91C1C', warning: '#B45309', info: '#1D4ED8'
    },
    typography: { headingWeight: '700', bodyWeight: '400', headingTransform: 'none', letterSpacing: '-0.01em', lineHeight: '1.6', headingSizeMultiplier: 1.05 },
    components: {
      button: { borderRadius: '8px', padding: '16px 42px', fontWeight: '700', textTransform: 'none' },
      card: { borderRadius: '16px', shadow: '0 10px 40px -10px rgba(0, 0, 0, 0.08)', borderWidth: '1px' },
      header: { backgroundColor: '#fff', fixedBackgroundColor: '#FFFFFF', textColor: '#000', linkHoverColor: '#B91C1C' },
      banner: { overlayColor: 'rgba(0, 0, 0, 0.26)', textColor: '#FFFFFF', accentColor: '#B91C1C' },
      menu: { tabActiveBackground: '#B91C1C', tabActiveText: '#FFFFFF', tabInactiveBackground: '#F9FAFB', tabInactiveText: '#374151', priceColor: '#B91C1C' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE2: {
    id: 'template2',
    name: 'Classic',
    description: 'Elegant and traditional design for fine dining establishments',
    fonts: {
      primary: "'Poppins', sans-serif",
      secondary: "'Poppins', sans-serif",
      heading: "'Poppins', sans-serif",
      googleFonts: 'family=Poppins:wght@300;400;500;600;700'
    },
    colors: {
      primary: '#7c2d12', secondary: '#1c1917', accent: '#d97706', accentAlt: '#92400e',
      text: '#292524', textLight: '#78716c', textInverse: '#fafaf9', background: '#fff',
      backgroundAlt: '#fff', backgroundDark: '#1c1917', border: '#e7e5e4', borderAccent: '#d97706',
      overlay: 'rgba(28, 25, 23, 0.85)', overlayLight: 'rgba(28, 25, 23, 0.6)', shadow: 'rgba(0, 0, 0, 0.1)',
      shadowStrong: 'rgba(0, 0, 0, 0.15)', success: '#10b981', error: '#f87171', warning: '#f59e0b', info: '#3b82f6'
    },
    typography: { headingWeight: '600', bodyWeight: '400', headingTransform: 'none', letterSpacing: '0.02em', lineHeight: '1.7', headingSizeMultiplier: 1.1 },
    components: {
      button: { borderRadius: '6px', padding: '16px 44px', fontWeight: '600', textTransform: 'uppercase' },
      card: { borderRadius: '8px', shadow: '0 2px 12px rgba(0, 0, 0, 0.1)', borderWidth: '2px' },
      header: { backgroundColor: '#fff', fixedBackgroundColor: '#1c1917', textColor: '#000', linkHoverColor: '#000' },
      banner: { overlayColor: 'rgba(0, 0, 0, 0.37)', textColor: '#fafaf9', accentColor: '#d97706' },
      menu: { tabActiveBackground: '#7c2d12', tabActiveText: '#fafaf9', tabInactiveBackground: '#f5f5f4', tabInactiveText: '#292524', priceColor: '#d97706' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE3: {
    id: 'template3',
    name: 'Traditional',
    description: 'Heritage Indian aesthetic with saffron & gold palette — ideal for sweets and mithai shops',
    fonts: {
      primary: "'Poppins', sans-serif",
      secondary: "'Poppins', sans-serif",
      heading: "'Poppins', sans-serif",
      googleFonts: 'family=Poppins:wght@300;400;500;600;700'
    },
    colors: {
      primary: '#B8541B', secondary: '#7B3F00', accent: '#D4A017', accentAlt: '#E8B84B',
      text: '#2C1810', textLight: '#6B4226', textInverse: '#FFF8EE', background: '#FFF8EE',
      backgroundAlt: '#FEF0D4', backgroundDark: '#3D1A00', border: '#E8D5B0', borderAccent: '#D4A017',
      overlay: 'rgba(60, 20, 0, 0.78)', overlayLight: 'rgba(60, 20, 0, 0.50)', shadow: 'rgba(184, 84, 27, 0.12)',
      shadowStrong: 'rgba(60, 20, 0, 0.20)', success: '#2D7D46', error: '#C0392B', warning: '#D4A017', info: '#1D6FA4'
    },
    typography: { headingWeight: '700', bodyWeight: '400', headingTransform: 'none', letterSpacing: '0.01em', lineHeight: '1.75', headingSizeMultiplier: 1.1 },
    components: {
      button: { borderRadius: '4px', padding: '14px 44px', fontWeight: '700', textTransform: 'uppercase' },
      card: { borderRadius: '8px', shadow: '0 4px 20px rgba(60, 20, 0, 0.10)', borderWidth: '1px' },
      header: { backgroundColor: '#FFF8EE', fixedBackgroundColor: '#3D1A00', textColor: '#2C1810', linkHoverColor: '#B8541B' },
      banner: { overlayColor: 'rgba(60, 20, 0, 0.60)', textColor: '#FFF8EE', accentColor: '#D4A017' },
      menu: { tabActiveBackground: '#B8541B', tabActiveText: '#FFF8EE', tabInactiveBackground: '#FEF0D4', tabInactiveText: '#2C1810', priceColor: '#B8541B' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE4: {
    id: 'template4',
    name: 'Asha Legacy',
    description: 'Heritage Premium aesthetic with maroon and gold highlights - perfect for legendary sweet shops.',
    fonts: {
      primary: "'Montserrat', sans-serif",
      secondary: "'Montserrat', sans-serif",
      heading: "'Montserrat', sans-serif",
      googleFonts: "family=Montserrat:wght@300;400;500;600;700;800&display=swap"
    },
    colors: {
      primary: '#D22B49', secondary: '#1A1A1A', accent: '#FFD700', accentAlt: '#FFD700',
      text: '#1A1A1A', textLight: '#666666', textInverse: '#FFFFFF', background: '#FFFFFF',
      backgroundAlt: '#F8F8F8', backgroundDark: '#1A1A1A', border: '#EEEEEE', borderAccent: '#D22B49',
      overlay: 'rgba(26, 26, 26, 0.8)', overlayLight: 'rgba(26, 26, 26, 0.4)', shadow: 'rgba(0, 0, 0, 0.08)',
      shadowStrong: 'rgba(0, 0, 0, 0.15)', success: '#15803D', error: '#D22B49', warning: '#FFD700', info: '#005F73'
    },
    typography: { headingWeight: '800', bodyWeight: '400', headingTransform: 'none', letterSpacing: '-0.01em', lineHeight: '1.6', headingSizeMultiplier: 1.15 },
    components: {
      button: { borderRadius: '5px', padding: '16px 45px', fontWeight: '700', textTransform: 'uppercase' },
      card: { borderRadius: '10px', shadow: '0 15px 40px rgba(0, 0, 0, 0.06)', borderWidth: '1px' },
      header: { backgroundColor: '#FFFFFF', fixedBackgroundColor: '#FFFFFF', textColor: '#1A1A1A', linkHoverColor: '#D22B49' },
      banner: { overlayColor: 'rgba(26, 26, 26, 0.6)', textColor: '#FFFFFF', accentColor: '#FFD700' },
      menu: { tabActiveBackground: '#D22B49', tabActiveText: '#FFFFFF', tabInactiveBackground: '#F8F8F8', tabInactiveText: '#1A1A1A', priceColor: '#D22B49' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE5: {
    id: 'template5',
    name: 'Apparel',
    description: 'Elegant layout specifically tailored for high-end apparel and fashion landing pages.',
    fonts: {
      primary: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      secondary: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      heading: "'Playfair Display', serif",
      googleFonts: "family=Inter:wght@300;400;500;600&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400"
    },
    colors: {
      primary: '#b58c73', secondary: '#4f3e33', accent: '#dcbba5', accentAlt: '#a17861',
      text: '#2c2825', textLight: '#78716c', textInverse: '#ffffff', background: '#eee6de',
      backgroundAlt: '#e2d5c8', backgroundDark: '#2c2825', border: '#dcbba5', borderAccent: '#b58c73',
      overlay: 'rgba(44, 40, 37, 0.7)', overlayLight: 'rgba(44, 40, 37, 0.4)', shadow: 'rgba(0, 0, 0, 0.1)',
      shadowStrong: 'rgba(0, 0, 0, 0.2)', success: '#10b981', error: '#f87171', warning: '#f59e0b', info: '#3b82f6'
    },
    typography: { headingWeight: '600', bodyWeight: '300', headingTransform: 'none', letterSpacing: '0.03em', lineHeight: '1.8', headingSizeMultiplier: 1.15 },
    components: {
      button: { borderRadius: '0px', padding: '16px 40px', fontWeight: '500', textTransform: 'uppercase' },
      card: { borderRadius: '0px', shadow: '0 5px 20px rgba(0, 0, 0, 0.05)', borderWidth: '0px' },
      header: { backgroundColor: '#eee6de', fixedBackgroundColor: '#eee6de', textColor: '#2c2825', linkHoverColor: '#b58c73' },
      banner: { overlayColor: 'transparent', textColor: '#ffffff', accentColor: '#b58c73' },
      menu: { tabActiveBackground: '#b58c73', tabActiveText: '#ffffff', tabInactiveBackground: 'transparent', tabInactiveText: '#2c2825', priceColor: '#4f3e33' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE6: {
    id: 'template6',
    name: 'Luxury Restaurant',
    description: 'Ultra-premium fine dining aesthetic with deep greens, elegant arch layouts, and floating photography.',
    fonts: {
      primary: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      secondary: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      heading: "'Playfair Display', serif",
      googleFonts: "family=Inter:wght@300;400;500;600&family=Playfair+Display:ital,wght@0,400;0,600;0,700&display=swap"
    },
    colors: {
      primary: '#1a4d2e', secondary: '#faf3e0', accent: '#d4af37', accentAlt: '#1a4d2e',
      text: '#1a1a1a', textLight: '#555555', textInverse: '#ffffff', background: '#ffffff',
      backgroundAlt: '#fcfbf7', backgroundDark: '#123720', border: '#e5e7eb', borderAccent: '#1a4d2e',
      overlay: 'rgba(26, 77, 46, 0.7)', overlayLight: 'rgba(26, 77, 46, 0.4)', shadow: 'rgba(0, 0, 0, 0.08)',
      shadowStrong: 'rgba(0, 0, 0, 0.15)', success: '#10b981', error: '#f87171', warning: '#f59e0b', info: '#3b82f6'
    },
    typography: { headingWeight: '700', bodyWeight: '300', headingTransform: 'none', letterSpacing: '0.01em', lineHeight: '1.7', headingSizeMultiplier: 1.1 },
    components: {
      button: { borderRadius: '50px', padding: '16px 42px', fontWeight: '600', textTransform: 'none' },
      card: { borderRadius: '20px', shadow: '0 15px 40px rgba(26, 77, 46, 0.08)', borderWidth: '0px' },
      header: { backgroundColor: '#ffffff', fixedBackgroundColor: '#ffffff', textColor: '#1a1a1a', linkHoverColor: '#d4af37' },
      banner: { overlayColor: 'transparent', textColor: '#ffffff', accentColor: '#d4af37' },
      menu: { tabActiveBackground: '#1a4d2e', tabActiveText: '#ffffff', tabInactiveBackground: '#fcfbf7', tabInactiveText: '#1a1a1a', priceColor: '#1a4d2e' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE7: {
    id: 'template7',
    name: 'Sweet Shop Premium',
    description: 'A charming and elegant design for sweet shops, featuring soft curves, rich maroon & emerald colors, and festive gold accents.',
    fonts: {
      primary: "'Poppins', sans-serif",
      secondary: "'Outfit', sans-serif",
      heading: "'Playfair Display', serif",
      googleFonts: "family=Poppins:wght@300;400;500;600&family=Playfair+Display:ital,wght@0,400;0,600;0,700&family=Outfit:wght@300;400;500;600&display=swap"
    },
    colors: {
      primary: '#4B211A', secondary: '#004D3F', accent: '#D4AF37', accentAlt: '#004D3F',
      text: '#2C1810', textLight: '#6B4226', textInverse: '#ffffff', background: '#FFFDF5',
      backgroundAlt: '#F8F1E5', backgroundDark: '#2C1810', border: '#E8D5B0', borderAccent: '#4B211A',
      overlay: 'rgba(75, 33, 26, 0.7)', overlayLight: 'rgba(75, 33, 26, 0.4)', shadow: 'rgba(75, 33, 26, 0.08)',
      shadowStrong: 'rgba(75, 33, 26, 0.15)', success: '#10b981', error: '#f87171', warning: '#f59e0b', info: '#3b82f6'
    },
    typography: { headingWeight: '700', bodyWeight: '400', headingTransform: 'none', letterSpacing: '0.01em', lineHeight: '1.7', headingSizeMultiplier: 1.2 },
    components: {
      button: { borderRadius: '30px', padding: '14px 40px', fontWeight: '600', textTransform: 'none' },
      card: { borderRadius: '24px', shadow: '0 20px 40px rgba(75, 33, 26, 0.06)', borderWidth: '0px' },
      header: { backgroundColor: '#FFFDF5', fixedBackgroundColor: '#ffffff', textColor: '#4B211A', linkHoverColor: '#D4AF37' },
      banner: { overlayColor: 'rgba(0, 0, 0, 0.3)', textColor: '#ffffff', accentColor: '#D4AF37' },
      menu: { tabActiveBackground: '#4B211A', tabActiveText: '#ffffff', tabInactiveBackground: '#F8F1E5', tabInactiveText: '#4B211A', priceColor: '#004D3F' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE8: {
    id: 'template8',
    name: 'Heritage Royal',
    description: 'A regal Indian sweet store aesthetic with deep crimson, royal gold, and cream — ornate dividers, serif typography, and heritage motifs.',
    fonts: {
      primary: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      secondary: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      heading: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      googleFonts: "family=Poppins:wght@300;400;500;600;700;800&display=swap"
    },
    colors: {
      primary: '#8B1A1A', secondary: '#3D0C02', accent: '#C5A028', accentAlt: '#A8860C',
      text: '#2A1506', textLight: '#6D4C30', textInverse: '#FFF8EE', background: '#FFF5E1',
      backgroundAlt: '#FAECD0', backgroundDark: '#2A1506', border: '#E8D5B0', borderAccent: '#C5A028',
      overlay: 'rgba(139, 26, 26, 0.75)', overlayLight: 'rgba(139, 26, 26, 0.45)', shadow: 'rgba(139, 26, 26, 0.10)',
      shadowStrong: 'rgba(42, 21, 6, 0.20)', success: '#2D7D46', error: '#C0392B', warning: '#C5A028', info: '#1D6FA4'
    },
    typography: { headingWeight: '700', bodyWeight: '400', headingTransform: 'none', letterSpacing: '0.02em', lineHeight: '1.75', headingSizeMultiplier: 1.15 },
    components: {
      button: { borderRadius: '4px', padding: '16px 48px', fontWeight: '700', textTransform: 'uppercase' },
      card: { borderRadius: '8px', shadow: '0 8px 30px rgba(139, 26, 26, 0.08)', borderWidth: '2px' },
      header: { backgroundColor: '#FFF5E1', fixedBackgroundColor: '#2A1506', textColor: '#2A1506', linkHoverColor: '#8B1A1A' },
      banner: { overlayColor: 'rgba(42, 21, 6, 0.55)', textColor: '#FFF8EE', accentColor: '#C5A028' },
      menu: { tabActiveBackground: '#8B1A1A', tabActiveText: '#FFF8EE', tabInactiveBackground: '#FAECD0', tabInactiveText: '#2A1506', priceColor: '#8B1A1A' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE9: {
    id: 'template9',
    name: 'Modern Mithai',
    description: 'A contemporary boutique sweet shop design with deep teal, warm gold, and clean white — rounded shapes, airy layouts, and premium typography.',
    fonts: {
      primary: "'DM Sans', sans-serif",
      secondary: "'DM Sans', sans-serif",
      heading: "'DM Serif Display', serif",
      googleFonts: "family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&display=swap"
    },
    colors: {
      primary: '#005F73', secondary: '#0A2540', accent: '#E9D8A6', accentAlt: '#94D2BD',
      text: '#1A1A2E', textLight: '#64748B', textInverse: '#FFFFFF', background: '#FFFFFF',
      backgroundAlt: '#F8F6F0', backgroundDark: '#0A2540', border: '#E2E8F0', borderAccent: '#005F73',
      overlay: 'rgba(0, 95, 115, 0.70)', overlayLight: 'rgba(0, 95, 115, 0.40)', shadow: 'rgba(0, 95, 115, 0.08)',
      shadowStrong: 'rgba(10, 37, 64, 0.15)', success: '#10B981', error: '#EF4444', warning: '#F59E0B', info: '#3B82F6'
    },
    typography: { headingWeight: '400', bodyWeight: '400', headingTransform: 'none', letterSpacing: '-0.01em', lineHeight: '1.7', headingSizeMultiplier: 1.2 },
    components: {
      button: { borderRadius: '50px', padding: '15px 42px', fontWeight: '600', textTransform: 'none' },
      card: { borderRadius: '20px', shadow: '0 12px 40px rgba(0, 95, 115, 0.06)', borderWidth: '0px' },
      header: { backgroundColor: '#FFFFFF', fixedBackgroundColor: '#FFFFFF', textColor: '#1A1A2E', linkHoverColor: '#005F73' },
      banner: { overlayColor: 'rgba(10, 37, 64, 0.45)', textColor: '#FFFFFF', accentColor: '#E9D8A6' },
      menu: { tabActiveBackground: '#005F73', tabActiveText: '#FFFFFF', tabInactiveBackground: '#F8F6F0', tabInactiveText: '#1A1A2E', priceColor: '#005F73' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE10: {
    id: 'template10',
    name: 'Festive Sweets',
    description: 'A vibrant and joyful design with bright pink and yellow accents - ideal for celebratory sweets.',
    fonts: {
      primary: "'Poppins', sans-serif",
      secondary: "'Poppins', sans-serif",
      heading: "'Poppins', sans-serif",
      googleFonts: 'family=Poppins:wght@300;400;500;600;700'
    },
    colors: {
      primary: '#C2185B', secondary: '#F9A825', accent: '#F9A825', accentAlt: '#880E4F',
      text: '#311B92', textLight: '#4527A0', textInverse: '#FFFFFF', background: '#FCE4EC',
      backgroundAlt: '#F8BBD0', backgroundDark: '#880E4F', border: '#F48FB1', borderAccent: '#C2185B',
      overlay: 'rgba(136, 14, 79, 0.8)', overlayLight: 'rgba(136, 14, 79, 0.4)', shadow: 'rgba(0, 0, 0, 0.08)',
      shadowStrong: 'rgba(0, 0, 0, 0.15)', success: '#2E7D32', error: '#C62828', warning: '#F9A825', info: '#1565C0'
    },
    typography: { headingWeight: '700', bodyWeight: '400', headingTransform: 'uppercase', letterSpacing: '0.05em', lineHeight: '1.6', headingSizeMultiplier: 1.1 },
    components: {
      button: { borderRadius: '50px', padding: '14px 40px', fontWeight: '700', textTransform: 'uppercase' },
      card: { borderRadius: '25px', shadow: '0 10px 30px rgba(194, 24, 91, 0.15)', borderWidth: '2px' },
      header: { backgroundColor: '#FCE4EC', fixedBackgroundColor: '#FCE4EC', textColor: '#311B92', linkHoverColor: '#C2185B' },
      banner: { overlayColor: 'rgba(0, 0, 0, 0.2)', textColor: '#FFFFFF', accentColor: '#F9A825' },
      menu: { tabActiveBackground: '#C2185B', tabActiveText: '#FFFFFF', tabInactiveBackground: '#F8BBD0', tabInactiveText: '#311B92', priceColor: '#C2185B' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE11: {
    id: 'template11',
    name: 'Royal Confections',
    description: 'A sophisticated and regal design with deep navy and rose gold - perfect for premium boutiques.',
    fonts: {
      primary: "'Montserrat', sans-serif",
      secondary: "'Montserrat', sans-serif",
      heading: "'Montserrat', sans-serif",
      googleFonts: 'family=Montserrat:wght@300;400;500;600;700'
    },
    colors: {
      primary: '#B76E79', secondary: '#1A1A1E', accent: '#D4AF37', accentAlt: '#B76E79',
      text: '#1A1A1E', textLight: '#4A4A4A', textInverse: '#FFFFFF', background: '#FFFFFF',
      backgroundAlt: '#F5F5F7', backgroundDark: '#1A1A1E', border: '#E5E5E5', borderAccent: '#B76E79',
      overlay: 'rgba(26, 26, 30, 0.85)', overlayLight: 'rgba(26, 26, 30, 0.5)', shadow: 'rgba(0, 0, 0, 0.1)',
      shadowStrong: 'rgba(0, 0, 0, 0.2)', success: '#4CAF50', error: '#E91E63', warning: '#FFC107', info: '#2196F3'
    },
    typography: { headingWeight: '600', bodyWeight: '400', headingTransform: 'uppercase', letterSpacing: '0.1em', lineHeight: '1.8', headingSizeMultiplier: 1.0 },
    components: {
      button: { borderRadius: '0px', padding: '16px 45px', fontWeight: '500', textTransform: 'uppercase' },
      card: { borderRadius: '0px', shadow: '0 5px 25px rgba(0, 0, 0, 0.05)', borderWidth: '1px' },
      header: { backgroundColor: '#FFFFFF', fixedBackgroundColor: '#1A1A1E', textColor: '#1A1A1E', linkHoverColor: '#B76E79' },
      banner: { overlayColor: 'rgba(26, 26, 30, 0.6)', textColor: '#FFFFFF', accentColor: '#B76E79' },
      menu: { tabActiveBackground: '#B76E79', tabActiveText: '#FFFFFF', tabInactiveBackground: '#F5F5F7', tabInactiveText: '#1A1A1E', priceColor: '#B76E79' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE12: {
    id: 'template12',
    name: 'Traditional Sweets',
    description: 'A warm, heritage-inspired design for traditional Indian sweet shops with earthy tones and classic motifs.',
    fonts: { primary: 'sans-serif', secondary: 'sans-serif', heading: 'sans-serif', googleFonts: '' },
    colors: { primary: '#111', secondary: '#222', accent: '#333', text: '#000', background: '#fff' },
    typography: { headingWeight: '700', bodyWeight: '400' },
    components: {
      button: { borderRadius: '4px', padding: '12px 30px' },
      card: { borderRadius: '8px' },
      header: { backgroundColor: '#FFFFFF', fixedBackgroundColor: '#111111', textColor: '#000000', linkHoverColor: '#111111' },
      banner: { overlayColor: 'rgba(0,0,0,0.5)', textColor: '#fff', accentColor: '#111' },
      menu: { tabActiveBackground: '#111', tabActiveText: '#fff' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE13: {
    id: 'template13',
    name: 'Sunburst Gourmet',
    description: 'A modern gourmet design with dramatic radial rays and floating cards — bold and contemporary.',
    fonts: { primary: 'sans-serif', secondary: 'sans-serif', heading: 'sans-serif', googleFonts: '' },
    colors: { primary: '#111', secondary: '#222', accent: '#333', text: '#000', background: '#fff' },
    typography: { headingWeight: '700', bodyWeight: '400' },
    components: {
      button: { borderRadius: '4px', padding: '12px 30px' },
      card: { borderRadius: '8px' },
      header: { backgroundColor: '#FFFFFF', fixedBackgroundColor: '#111111', textColor: '#000000', linkHoverColor: '#111111' },
      banner: { overlayColor: 'rgba(0,0,0,0.5)', textColor: '#fff', accentColor: '#111' },
      menu: { tabActiveBackground: '#111', tabActiveText: '#fff' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE14: {
    id: 'template14',
    name: 'Café Premium',
    description: 'A luxury café & coffee shop template with rich espresso browns, warm cream tones, and gold accents — inspired by Starbucks, Blue Tokai, and premium roasters.',
    fonts: {
      primary: "'Outfit', -apple-system, BlinkMacSystemFont, sans-serif",
      secondary: "'Outfit', -apple-system, BlinkMacSystemFont, sans-serif",
      heading: "'Playfair Display', serif",
      googleFonts: "family=Outfit:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&display=swap"
    },
    colors: {
      primary: '#3C2415', secondary: '#1A0E0A', accent: '#C8A97E', accentAlt: '#8B6914',
      text: '#2C1810', textLight: '#7A6555', textInverse: '#FFF8F0', background: '#FDF8F3',
      backgroundAlt: '#F5EDE4', backgroundDark: '#1A0E0A', border: '#E8DDD2', borderAccent: '#C8A97E',
      overlay: 'rgba(26, 14, 10, 0.82)', overlayLight: 'rgba(26, 14, 10, 0.50)', shadow: 'rgba(60, 36, 21, 0.10)',
      shadowStrong: 'rgba(26, 14, 10, 0.20)', success: '#2D7D46', error: '#C0392B', warning: '#D4A017', info: '#1D6FA4'
    },
    typography: { headingWeight: '700', bodyWeight: '400', headingTransform: 'none', letterSpacing: '0.01em', lineHeight: '1.7', headingSizeMultiplier: 1.15 },
    components: {
      button: { borderRadius: '50px', padding: '16px 44px', fontWeight: '600', textTransform: 'none' },
      card: { borderRadius: '20px', shadow: '0 16px 48px rgba(60, 36, 21, 0.08)', borderWidth: '0px' },
      header: { backgroundColor: 'transparent', fixedBackgroundColor: '#1A0E0A', textColor: '#FFF8F0', linkHoverColor: '#C8A97E' },
      banner: { overlayColor: 'rgba(26, 14, 10, 0.55)', textColor: '#FFF8F0', accentColor: '#C8A97E' },
      menu: { tabActiveBackground: '#3C2415', tabActiveText: '#FFF8F0', tabInactiveBackground: '#F5EDE4', tabInactiveText: '#3C2415', priceColor: '#3C2415' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "MenuSection" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE15: {
    id: 'template15',
    name: 'Dry Fruits',
    description: 'An earthy, elegant template for dry fruits, nuts and spices retailers.',
    fonts: {
      primary: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      secondary: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      heading: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      googleFonts: "family=Inter:wght@300;400;500;600;700;800&display=swap"
    },
    colors: {
      primary: '#9F6B3F', secondary: '#3D2B1F', accent: '#D4A373', accentAlt: '#8B5A2B',
      text: '#2C231F', textLight: '#7A6E67', textInverse: '#FFFFFF', background: '#FAFAFA',
      backgroundAlt: '#F5F5F5', backgroundDark: '#3D2B1F', border: '#EAE6E1', borderAccent: '#9F6B3F',
      overlay: 'rgba(61, 43, 31, 0.7)', overlayLight: 'rgba(61, 43, 31, 0.4)', shadow: 'rgba(159, 107, 63, 0.1)',
      shadowStrong: 'rgba(159, 107, 63, 0.18)', success: '#2E7D32', error: '#C62828', warning: '#D4A373', info: '#1976D2'
    },
    typography: { headingWeight: '600', bodyWeight: '400', headingTransform: 'none', letterSpacing: '0.02em', lineHeight: '1.6', headingSizeMultiplier: 1.1 },
    components: {
      button: { borderRadius: '25px', padding: '12px 35px', fontWeight: '500', textTransform: 'none' },
      card: { borderRadius: '12px', shadow: '0 8px 24px rgba(0, 0, 0, 0.06)', borderWidth: '0px' },
      header: { backgroundColor: '#FFFFFF', fixedBackgroundColor: '#FFFFFF', textColor: '#2C231F', linkHoverColor: '#9F6B3F' },
      banner: { overlayColor: 'rgba(0, 0, 0, 0.05)', textColor: '#9F6B3F', accentColor: '#9F6B3F' },
      menu: { tabActiveBackground: '#9F6B3F', tabActiveText: '#FFFFFF', tabInactiveBackground: '#F5F5F5', tabInactiveText: '#2C231F', priceColor: '#2C231F' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "MenuSection" }, { type: "About" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "TestimonialSection" }, { type: "GallerySection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  },

  TEMPLATE16: {
    id: 'template16',
    name: 'Arisa Collection',
    description: 'A premium, editorial-styled template for boutique sweet & mithai stores — muted wine and antique gold, generous white space, heritage storytelling.',
    fonts: {
      primary: "'Jost', -apple-system, BlinkMacSystemFont, sans-serif",
      secondary: "'Jost', -apple-system, BlinkMacSystemFont, sans-serif",
      heading: "'Cormorant', serif",
      googleFonts: "family=Cormorant:ital,wght@0,400;0,500;0,600;0,700;1,400&family=Jost:wght@300;400;500;600;700&display=swap"
    },
    colors: {
      primary: '#6B2E3A', secondary: '#2B1D16', accent: '#B08D57', accentAlt: '#8C6A3F',
      text: '#2B1D16', textLight: '#7A6A5D', textInverse: '#FFFCF7', background: '#FFFCF7',
      backgroundAlt: '#F3EAE0', backgroundDark: '#2B1D16', border: '#E8DCC8', borderAccent: '#B08D57',
      overlay: 'rgba(43, 29, 22, 0.72)', overlayLight: 'rgba(43, 29, 22, 0.42)', shadow: 'rgba(107, 46, 58, 0.10)',
      shadowStrong: 'rgba(43, 29, 22, 0.20)', success: '#3E7D4A', error: '#B23B2E', warning: '#B08D57', info: '#3B6E91'
    },
    typography: { headingWeight: '600', bodyWeight: '400', headingTransform: 'none', letterSpacing: '0.01em', lineHeight: '1.75', headingSizeMultiplier: 1.2 },
    components: {
      button: { borderRadius: '8px', padding: '15px 40px', fontWeight: '600', textTransform: 'none' },
      card: { borderRadius: '16px', shadow: '0 14px 36px rgba(43, 29, 22, 0.08)', borderWidth: '0px' },
      header: { backgroundColor: '#FFFCF7', fixedBackgroundColor: '#FFFCF7', textColor: '#2B1D16', linkHoverColor: '#6B2E3A' },
      banner: { overlayColor: 'rgba(43, 29, 22, 0.45)', textColor: '#FFFCF7', accentColor: '#B08D57' },
      menu: { tabActiveBackground: '#6B2E3A', tabActiveText: '#FFFCF7', tabInactiveBackground: '#F3EAE0', tabInactiveText: '#2B1D16', priceColor: '#6B2E3A' },
      defaultSections: [{ type: "Banner" }, { type: "CategoryGrid" }, { type: "TrustBadges" }, { type: "SpecialMenu" }, { type: "About" }, { type: "GallerySection" }, { type: "TestimonialSection" }, { type: "ProcessSection" }, { type: "TeamSection" }, { type: "BlogSection" }, { type: "MapSection" }]
    }
  }
};

// Aliases for backward compatibility (Ordered numerically 1-13)
TEMPLATES.MODERN = TEMPLATES.TEMPLATE1;
TEMPLATES.CLASSIC = TEMPLATES.TEMPLATE2;
TEMPLATES.TRADITIONAL = TEMPLATES.TEMPLATE3;
TEMPLATES.ASHA_LEGACY = TEMPLATES.TEMPLATE4;
TEMPLATES.APPAREL = TEMPLATES.TEMPLATE5;
TEMPLATES.LUXURY_RESTAURANT = TEMPLATES.TEMPLATE6;
TEMPLATES.SWEET_SHOP = TEMPLATES.TEMPLATE7;
TEMPLATES.HERITAGE_ROYAL = TEMPLATES.TEMPLATE8;
TEMPLATES.MODERN_MITHAI = TEMPLATES.TEMPLATE9;
TEMPLATES.FESTIVE_SWEETS = TEMPLATES.TEMPLATE10;
TEMPLATES.ROYAL_CONFECTIONS = TEMPLATES.TEMPLATE11;
TEMPLATES.TRADITIONAL_SWEETS = TEMPLATES.TEMPLATE12;
TEMPLATES.SUNBURST_GOURMET = TEMPLATES.TEMPLATE13;
TEMPLATES.CAFE_PREMIUM = TEMPLATES.TEMPLATE14;
TEMPLATES.DRY_FRUITS = TEMPLATES.TEMPLATE15;
TEMPLATES.ARISA_COLLECTION = TEMPLATES.TEMPLATE16;

/**
 * Apply branding API colors to a template
 */
export const applyBrandingToTemplate = (template, brandingData) => {
  if (!brandingData?.theme_colors) {
    return template;
  }

  const cleanColor = (color) => {
    if (!color) return null;
    return color.replace(/[`'"]/g, '').trim();
  };

  const apiColors = {
    primary: cleanColor(brandingData.theme_colors.primary),
    secondary: cleanColor(brandingData.theme_colors.secondary),
    accent: cleanColor(brandingData.theme_colors.accent),
    text: cleanColor(brandingData.theme_colors.text),
    background: cleanColor(brandingData.theme_colors.background),
    fontFamily: brandingData.typography?.font_family
  };

  const fontStack = apiColors.fontFamily
    ? `'${apiColors.fontFamily}', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`
    : template.fonts.primary;

  const fontNameForGoogle = apiColors.fontFamily ? apiColors.fontFamily.replace(/\s+/g, '+') : null;
  const googleFonts = fontNameForGoogle
    ? `family=${fontNameForGoogle}:wght@300;400;500;600;700&display=swap`
    : template.fonts.googleFonts;

  return {
    ...template,
    fonts: {
      ...template.fonts,
      primary: fontStack,
      secondary: fontStack,
      heading: fontStack,
      googleFonts: googleFonts
    },
    colors: {
      ...template.colors,
      ...(apiColors.primary && {
        primary: apiColors.primary,
        borderAccent: apiColors.primary
      }),
      ...(apiColors.secondary && {
        secondary: apiColors.secondary
      }),
      ...(apiColors.accent && {
        accent: apiColors.accent,
        accentAlt: apiColors.accent
      })
    },
    components: {
      ...template.components,
      header: {
        ...template.components.header,
        ...(apiColors.primary && { linkHoverColor: apiColors.primary }),
        ...(apiColors.text && { textColor: apiColors.text })
      },
      banner: {
        ...template.components.banner,
        ...(apiColors.primary && { accentColor: apiColors.primary })
      },
      menu: {
        ...template.components.menu,
        ...(apiColors.primary && {
          tabActiveBackground: apiColors.primary,
          priceColor: apiColors.primary
        })
      }
    }
  };
};

/**
 * Get template with branding applied (ASYNC)
 */
export const getTemplate = async (templateType) => {
  const templateKey = (templateType || 'template1').toUpperCase().replace(/-/g, '_');
  const baseTemplate = TEMPLATES[templateKey] || TEMPLATES.TEMPLATE1;

  try {
    const brandingData = await brandingService.getBranding();
    if (brandingData) {
      return applyBrandingToTemplate(baseTemplate, brandingData);
    }
  } catch (error) {
    console.warn('⚠️ Error fetching branding:', error);
  }

  return baseTemplate;
};

/**
 * Get template with cached branding only (SYNC)
 */
export const getTemplateSync = (templateType) => {
  const templateKey = (templateType || 'template1').toUpperCase().replace(/-/g, '_');
  const baseTemplate = TEMPLATES[templateKey] || TEMPLATES.TEMPLATE1;

  const brandingData = brandingService.getCachedBranding();
  if (brandingData) {
    return applyBrandingToTemplate(baseTemplate, brandingData);
  }

  return baseTemplate;
};

/**
 * Pick a readable text color (near-white or near-black) for content sitting
 * on top of an arbitrary background color. Standard YIQ brightness formula —
 * used instead of a fixed/template-configured text color because the
 * background it needs to contrast against (--color-primary) can be
 * overridden per-tenant at runtime by the branding API (see
 * applyBrandingToTemplate above), so a color computed from whatever value
 * actually ends up in template.colors.primary is the only way to guarantee
 * readability for every tenant instead of just the templates' own defaults.
 */
const getReadableTextColor = (hex) => {
  if (typeof hex !== 'string') return '#ffffff';
  const clean = hex.trim().replace('#', '');
  const full = clean.length === 3 ? clean.split('').map(c => c + c).join('') : clean;
  if (!/^[0-9a-fA-F]{6}$/.test(full)) return '#ffffff';

  const r = parseInt(full.substring(0, 2), 16);
  const g = parseInt(full.substring(2, 4), 16);
  const b = parseInt(full.substring(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= 128 ? '#1a1a1a' : '#ffffff';
};

const hexToRgb = (hex) => {
  const clean = (hex || '').trim().replace('#', '');
  const full = clean.length === 3 ? clean.split('').map(c => c + c).join('') : clean;
  if (!/^[0-9a-fA-F]{6}$/.test(full)) return null;
  return {
    r: parseInt(full.substring(0, 2), 16),
    g: parseInt(full.substring(2, 4), 16),
    b: parseInt(full.substring(4, 6), 16)
  };
};

const relativeLuminance = ({ r, g, b }) => {
  const linear = (c) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  };
  return 0.2126 * linear(r) + 0.7152 * linear(g) + 0.0722 * linear(b);
};

// WCAG relative-luminance contrast ratio between two hex colors (1–21).
const getContrastRatio = (hexA, hexB) => {
  const rgbA = hexToRgb(hexA);
  const rgbB = hexToRgb(hexB);
  if (!rgbA || !rgbB) return 1;
  const lumA = relativeLuminance(rgbA);
  const lumB = relativeLuminance(rgbB);
  const lighter = Math.max(lumA, lumB);
  const darker = Math.min(lumA, lumB);
  return (lighter + 0.05) / (darker + 0.05);
};

const clamp255 = (n) => Math.min(255, Math.max(0, Math.round(n)));

const toHex2 = (n) => clamp255(n).toString(16).padStart(2, '0');

// Blends hexA and hexB, weightA = 0..1 share of hexA in the result.
const blendHex = (hexA, hexB, weightA) => {
  const rgbA = hexToRgb(hexA);
  const rgbB = hexToRgb(hexB);
  if (!rgbA) return hexB;
  if (!rgbB) return hexA;
  const w = Math.min(1, Math.max(0, weightA));
  const r = rgbA.r * w + rgbB.r * (1 - w);
  const g = rgbA.g * w + rgbB.g * (1 - w);
  const b = rgbA.b * w + rgbB.b * (1 - w);
  return `#${toHex2(r)}${toHex2(g)}${toHex2(b)}`;
};

/**
 * The footer keeps its text a fixed white for brand consistency (rather
 * than flipping to dark text on light-primary tenants, which is more
 * readable in isolation but reads as an off-brand mismatch against an
 * otherwise-colorful footer) — see the Footer-only contrast fix this
 * supports. To keep that white text ACTUALLY readable against any primary
 * color the branding API can send, not just the dark ones white already
 * suits, this computes a black scrim to sit behind the footer content: its
 * opacity is the minimum needed for white to clear a safe contrast ratio
 * against the darkened result, found by binary search (relative luminance
 * isn't linear in the blend weight, so this can't be solved directly).
 * Dark primaries need ~0 opacity (white was already fine); light ones need
 * more. Opacity is capped so the tenant's actual brand color still reads
 * through even for very light/near-white primaries, rather than the footer
 * becoming solid black — in that edge case the scrim does its best but may
 * not reach full AA compliance, a deliberate trade-off for keeping the
 * footer recognizably the tenant's brand color.
 */
const getFooterScrim = (primaryHex, targetRatio = 4.5, maxOpacity = 0.55) => {
  if (getContrastRatio('#ffffff', primaryHex) >= targetRatio) {
    return { opacity: 0, effectiveBg: primaryHex };
  }

  let lo = 0;
  let hi = maxOpacity;
  for (let i = 0; i < 12; i++) {
    const mid = (lo + hi) / 2;
    const candidateBg = blendHex('#000000', primaryHex, mid);
    if (getContrastRatio('#ffffff', candidateBg) >= targetRatio) {
      hi = mid;
    } else {
      lo = mid;
    }
  }

  return { opacity: hi, effectiveBg: blendHex('#000000', primaryHex, hi) };
};

/**
 * Footer section-heading color: must look visibly different from the
 * regular footer text color (never the same variable/value) while staying
 * guaranteed readable against the footer's effective (scrim-darkened)
 * background.
 *
 * Deliberately does NOT use the theme's own --color-accent for the tint,
 * even though that was the original intent (see git history) — the
 * branding API's init response always sets theme_colors.accent equal to
 * theme_colors.primary (see brandingService.js's mappedBrandingData), so
 * for every API-branded tenant --color-accent IS --color-primary. Blending
 * a color with a shade of itself never produces enough hue separation to
 * read as "different", so this silently fell back to plain body text below
 * every time in production — which is exactly why headings and body text
 * looked identical. A fixed warm gold (already this codebase's established
 * premium-accent convention, e.g. templates.css's var(--color-accent,
 * #FFD700) fallbacks) is used instead — independent of the tenant's actual
 * accent, so it stays genuinely distinct rather than only tinting a
 * random subset of tenants where accent happens to differ from primary.
 * Still blended toward the safe base color by a fixed, meaningful amount so
 * it never overrides its guaranteed lightness/contrast; if gold still
 * doesn't clear the WCAG AA large-text contrast threshold against this
 * particular background (e.g. the tenant's own primary IS gold/yellow), a
 * second, lighter-tinted blend is tried before finally falling back to the
 * plain safe color as a last resort.
 */
const FOOTER_HEADING_ACCENT = '#FFD700';

const getFooterHeadingColor = (primaryHex, bodyTextColor) => {
  const strongTint = blendHex(bodyTextColor, FOOTER_HEADING_ACCENT, 0.55); // 55% safe / 45% gold
  if (getContrastRatio(strongTint, primaryHex) >= 3) {
    return strongTint;
  }

  const lightTint = blendHex(bodyTextColor, FOOTER_HEADING_ACCENT, 0.8); // 80% safe / 20% gold
  if (getContrastRatio(lightTint, primaryHex) >= 3) {
    return lightTint;
  }

  return bodyTextColor;
};

/**
 * Generate CSS variables from template
 */
export const generateCSSVariables = (template) => {
  const primaryContrast = getReadableTextColor(template.colors.primary);
  const footerScrim = getFooterScrim(template.colors.primary);

  return {
    '--font-primary': template.fonts.primary,
    '--font-secondary': template.fonts.secondary,
    '--font-heading': template.fonts.heading,
    '--color-primary-contrast': primaryContrast,
    // Footer keeps fixed white text (see getFooterScrim) — headings are
    // computed against the scrim-darkened effective background, not the
    // raw primary, since that's what they actually render on top of.
    '--footer-heading-color': getFooterHeadingColor(footerScrim.effectiveBg, '#ffffff'),
    '--footer-scrim-opacity': footerScrim.opacity,
    '--color-primary': template.colors.primary,
    '--color-secondary': template.colors.secondary,
    '--color-accent': template.colors.accent,
    '--color-accent-alt': template.colors.accentAlt,
    '--color-text': template.colors.text,
    '--color-text-light': template.colors.textLight,
    '--color-text-inverse': template.colors.textInverse,
    '--color-background': template.colors.background,
    '--color-background-alt': template.colors.backgroundAlt,
    '--color-background-dark': template.colors.backgroundDark,
    '--color-border': template.colors.border,
    '--color-border-accent': template.colors.borderAccent,
    '--color-overlay': template.colors.overlay,
    '--color-overlay-light': template.colors.overlayLight,
    '--color-shadow': template.colors.shadow,
    '--color-shadow-strong': template.colors.shadowStrong,
    '--color-success': template.colors.success,
    '--color-error': template.colors.error,
    '--color-warning': template.colors.warning,
    '--color-info': template.colors.info,
    '--heading-weight': template.typography.headingWeight,
    '--body-weight': template.typography.bodyWeight,
    '--heading-transform': template.typography.headingTransform,
    '--letter-spacing': template.typography.letterSpacing,
    '--line-height': template.typography.lineHeight,
    '--heading-size-multiplier': template.typography.headingSizeMultiplier,
    '--button-border-radius': template.components.button.borderRadius,
    '--button-padding': template.components.button.padding,
    '--button-font-weight': template.components.button.fontWeight,
    '--button-text-transform': template.components.button.textTransform,
    '--card-border-radius': template.components.card.borderRadius,
    '--card-shadow': template.components.card.shadow,
    '--card-border-width': template.components.card.borderWidth,
    '--header-bg': template.components.header.backgroundColor,
    '--header-fixed-bg': template.components.header.fixedBackgroundColor,
    '--header-text': template.components.header.textColor,
    '--header-link-hover': template.components.header.linkHoverColor,
    '--banner-overlay': template.components.banner.overlayColor,
    '--banner-text': template.components.banner.textColor,
    '--banner-accent': template.components.banner.accentColor,
    '--menu-tab-active-bg': template.components.menu.tabActiveBackground,
    '--menu-tab-active-text': template.components.menu.tabActiveText,
    '--menu-tab-inactive-bg': template.components.menu.tabInactiveBackground,
    '--menu-tab-inactive-text': template.components.menu.tabInactiveText,
    '--menu-price-color': template.components.menu.priceColor
  };
};

export default TEMPLATES;